import React from "react";
import "katex/dist/katex.min.css";

/**
 * Renders rich-text HTML produced by the RichTextEditor.
 * Strips dangerous tags client-side via a simple allowlist.
 */
const ALLOWED_TAGS = new Set([
  "p", "br", "strong", "em", "b", "i", "code", "pre", "ul", "ol", "li",
  "blockquote", "a", "h1", "h2", "h3", "span", "annotation", "math",
  "semantics", "mrow", "msup", "msub", "mfrac", "mtext", "mi", "mo", "mn",
  "msqrt", "mtable", "mtr", "mtd", "munderover", "mover", "munder",
]);

function sanitize(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT);
  const toRemove = [];
  let node;
  while ((node = walker.nextNode())) {
    const tag = node.tagName.toLowerCase();
    if (!ALLOWED_TAGS.has(tag) && !node.classList.contains("katex") && !node.classList.contains("katex-rendered") && !tag.startsWith("m")) {
      // Keep katex-related elements and m* (MathML)
      if (!node.querySelector(".katex")) toRemove.push(node);
    }
    for (const attr of Array.from(node.attributes)) {
      if (attr.name.startsWith("on")) node.removeAttribute(attr.name);
      if (attr.name === "href" && /^javascript:/i.test(attr.value)) node.removeAttribute(attr.name);
    }
  }
  toRemove.forEach((n) => n.replaceWith(...n.childNodes));
  return doc.body.innerHTML;
}

export default function RichText({ html, className = "" }) {
  if (!html) return null;
  // If it doesn't look like HTML (no tags), render as plain text
  if (!/<[a-z][^>]*>/i.test(html)) return <span className={className}>{html}</span>;
  return (
    <div
      className={`rich-text [&_p]:my-1 [&_strong]:font-semibold [&_em]:italic [&_code]:bg-zinc-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.9em] [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_blockquote]:border-l-4 [&_blockquote]:border-zinc-300 [&_blockquote]:pl-4 [&_blockquote]:text-zinc-600 [&_.katex-rendered]:inline-block [&_a]:underline ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitize(html) }}
    />
  );
}
